import Repository from "../../repository";

export default {
    GetRecently: (payload) => Repository.post(`/api/Guests/NewsPublish/GetRecently`, payload),
    GetDetail: (payload) => Repository.post(`/api/Guests/NewsPublish/GetDetail`, payload),
    GetRandom: (payload) => Repository.post(`/api/Guests/NewsPublish/GetRandom`, payload),
    GetTop: (payload) => Repository.post(`/api/Guests/NewsPublish/GetTop`, payload),
    GetCount: (payload) => Repository.post(`/api/Guests/NewsPublish/GetCount`, payload),
    Get: (payload) => Repository.post(`/api/Guests/NewsPublish/Get`, payload),

}
